import PageHero from "./PageHero";

const AboutHero = () => {
  return (
    <PageHero
      title={<>About <span className="text-gradient-brand">AI-labbet</span></>}
      description="We guide organizations through the AI landscape with clear vision, solid strategy, and expert partnership."
      blobPosition="left"
    />
  );
};

export default AboutHero;
